import { ComponentPropsWithoutRef } from "react";
import Grid from "~/components/globals/Grid";
import * as styles from "./SectionGridArchive.css";
import { Heading } from "~/components/elements/Heading";
// @ts-ignore

export type SectionGridArchiveProps = ComponentPropsWithoutRef<"div"> & {
  columns?: 1 | 3;
  title?: string;
};

export const SectionGridArchive = ({
  children,
  columns = 3,
  title,
  ...props
}: SectionGridArchiveProps) => {
  return (
    <section>
      <Grid className={styles.gridWrapper}>
        <div className={styles.content}>
          {title && (
            <Heading as="h1" size="h1" uppercase bold>
              {title}
            </Heading>
          )}
          <div className={styles.grid({ gridColumns: columns })}>
            {children}
          </div>
        </div>
      </Grid>
    </section>
  );
};
